var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivities = function SvgActivities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.534 0H6.48a1.6 1.6 0 0 0-1.6 1.6v36.8a1.6 1.6 0 0 0 1.6 1.6h26.054a1.6 1.6 0 0 0 1.6-1.6V1.6a1.6 1.6 0 0 0-1.6-1.6Z",
    fill: "#1782E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.134 4.305H4.88v29.138h29.254V4.305Z",
    fill: "#1A63A6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "activities_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 31,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.134 4.304H4.88v29.138h29.254V4.304Z",
    fill: "#1A63A6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#activities_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.944 33.843c-.364-2.483 1.324-4.935 3.543-6.103 1.528-.804 3.392-1.2 4.403-2.6 1.512-2.09.24-5.086.988-7.558a4.765 4.765 0 0 1 2.188-2.731c1.356-.764 3.183-.94 3.99-2.272.649-1.068.34-2.431.489-3.675.316-2.643 2.72-4.575 5.203-5.53a14.99 14.99 0 0 1 4.599-.985c1.124-.06 2.311.024 3.267.62 1.12.7 1.74 2 1.992 3.296.252 1.295.192 2.631.276 3.947.144 2.2.688 4.347 1.012 6.527.515 3.45.475 6.958.431 10.45-.032 2.847-.088 5.794-1.295 8.37-.252.536-.564 1.064-1.044 1.407-.648.464-1.496.52-2.296.528a32.623 32.623 0 0 1-8.482-1.023c-2.955-.76-5.855-1.944-8.906-2.016-2.971-.072-5.915.916-8.878.68-.952-.076-2.084-.456-2.264-1.396",
    fill: "#124271"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.508 38.31a1.612 1.612 0 1 0 0-3.224 1.612 1.612 0 0 0 0 3.223Z",
    fill: "#124271"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.46 8.703H26.123a1.6 1.6 0 0 0-1.6 1.6v24.919a1.6 1.6 0 0 0 1.6 1.6H39.46a1.6 1.6 0 0 0 1.6-1.6v-24.92a1.6 1.6 0 0 0-1.6-1.599Z",
    fill: "#FF8257"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.06 12.336H24.523v19.28H41.06v-19.28Z",
    fill: "#A5F9E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.794 35.267a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z",
    fill: "#A84E39"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.912 23.145a3.971 3.971 0 1 0 0-7.942 3.971 3.971 0 0 0 0 7.942Z",
    fill: "#A5F9E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.134 6.762a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2Z",
    fill: "#FF8257"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m32.176 17.87-3.299 3.385a.8.8 0 0 0 .015 1.131l3.386 3.299a.8.8 0 0 0 1.131-.015l3.299-3.386a.8.8 0 0 0-.015-1.131l-3.386-3.299a.8.8 0 0 0-1.131.015Z",
    fill: "#1782E5"
  })));
};
export default SvgActivities;